
  import { Vue, Component, Prop } from "vue-property-decorator";

  import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
  import UiButton from "@/components/button/ui-button.vue";

  @Component({
    components: {
      ModalFullScreen,
      UiButton,
    },
  })
  export default class ModalWithTrigger extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;
    @Prop({ type: String, default: "" }) readonly defaultButtonText!: string;

    modalOpened: boolean = false;

    closeModal(): void {
      this.modalOpened = false;
    }

    openModal(): void {
      this.modalOpened = true;
    }
  }
